import styled from 'styled-components';
import List from '@material-ui/core/List';
export const StyledListBody = styled(List)`
  width: 100%;
  max-width: 360px;
  background-color: #ffffff;
`;
export const StyledBody = styled.div`
  width: 300px;
  margin: 38px;
`;